import type { Appearance } from '@lastrouter/contracts';
import { checkAccent, isHexColor } from '@lastrouter/ui';

export type ThemePreference = 'system' | 'light' | 'dark';
const THEME_KEY = 'lastrouter.tema';

export function loadTheme(): ThemePreference {
  try {
    const v = localStorage.getItem(THEME_KEY);
    if (v === 'light' || v === 'dark' || v === 'system') return v;
  } catch {
    // armazenamento bloqueado
  }
  return 'system';
}

/** Classe no <html>: .dark força o escuro, .light força o claro, nenhuma segue o sistema. */
export function applyTheme(pref: ThemePreference): void {
  const root = document.documentElement;
  root.classList.toggle('dark', pref === 'dark');
  root.classList.toggle('light', pref === 'light');
  try {
    localStorage.setItem(THEME_KEY, pref);
  } catch {
    // preferência só desta sessão
  }
  window.dispatchEvent(new Event('lastrouter:tema'));
}

const NAV_KEY = 'lastrouter.menu-recolhido';

/** Menu lateral recolhido (só ícones) no desktop. */
export function loadNavCollapsed(): boolean {
  try {
    return localStorage.getItem(NAV_KEY) === '1';
  } catch {
    return false;
  }
}

export function saveNavCollapsed(collapsed: boolean): void {
  try {
    localStorage.setItem(NAV_KEY, collapsed ? '1' : '0');
  } catch {
    // preferência só desta sessão
  }
}

export function isDarkActive(): boolean {
  const root = document.documentElement;
  if (root.classList.contains('dark')) return true;
  if (root.classList.contains('light')) return false;
  return typeof matchMedia === 'function' && matchMedia('(prefers-color-scheme: dark)').matches;
}

/**
 * Camada de marca do cliente: só a cor de destaque, o nome e o ícone. A cor só é aplicada se
 * passar no contraste; senão fica a da Cluster, para um tema mal escolhido não quebrar a leitura.
 */
export function applyBrand(a: Pick<Appearance, 'accent_color' | 'assistant_name' | 'icon'>): void {
  const root = document.documentElement;
  if (isHexColor(a.accent_color) && checkAccent(a.accent_color).ok) root.style.setProperty('--accent', a.accent_color);
  else root.style.removeProperty('--accent');
  document.title = `${a.assistant_name} · Lastrouter`;
  if (a.icon) {
    let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.head.appendChild(link);
    }
    link.href = a.icon;
  }
}
